import { render, staticRenderFns } from "./ParticipantSettings.vue?vue&type=template&id=cd0629fa&scoped=true"
import script from "./ParticipantSettings.vue?vue&type=script&lang=js"
export * from "./ParticipantSettings.vue?vue&type=script&lang=js"
import style0 from "./ParticipantSettings.vue?vue&type=style&index=0&id=cd0629fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0629fa",
  null
  
)

export default component.exports